import { apiRequest } from 'utils/axios'
import { COMMON_APIS } from 'utils/eps'

export const SIDEBAR_COUNT_GET = (): Promise<unknown> => {
    return apiRequest.withToken({ url: COMMON_APIS.SIDEBAR_COUNT, method: 'get' })
}
